/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Case_Age_DescriptionInputs */

const en_dashboard_case_age_description = /** @type {(inputs: Dashboard_Case_Age_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open cases grouped into three-month periods from the incident date.`)
};

const pt_br2_dashboard_case_age_description = /** @type {(inputs: Dashboard_Case_Age_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Casos abertos agrupados em períodos de três meses desde a data do sinistro.`)
};

/**
* | output |
* | --- |
* | "Open cases grouped into three-month periods from the incident date." |
*
* @param {Dashboard_Case_Age_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_case_age_description = /** @type {((inputs?: Dashboard_Case_Age_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Case_Age_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_case_age_description(inputs)
	return pt_br2_dashboard_case_age_description(inputs)
});